// PATIENT API
import Request from '../base'
export default {
  save (options) {
    return Request.post('/ebermain/mainapi/patient/potential/save', options)
  },
  delete (options) {
    return Request.post('/ebermain/mainapi/patient/potential/delete', options)
  },
  load (options) {
    return Request.post('/ebermain/mainapi/patient/potential/load', options)
  },
  list (options) {
    return Request.post('/ebermain/mainapi/patient/potential/list', options)
  },
  find (pagination, options) {
    if (!pagination.sort) {
      pagination.sort = 'updateTime'
    }
    if (!pagination.order) {
      pagination.order = 'DESC'
    }
    return Request.post('/ebermain/mainapi/patient/potential/find', Request.paginationBody(options, pagination))
  },
  saveSymptom (options) {
    return Request.post('/ebermain/mainapi/patient/symptom/save', options)
  },
  deleteSymptom (options) {
    return Request.post('/ebermain/mainapi/patient/symptom/delete', options)
  },
  loadSymptom (options) {
    return Request.post('/ebermain/mainapi/patient/symptom/load', options)
  },
  listSymptom (options) {
    return Request.post('/ebermain/mainapi/patient/symptom/list', options)
  },
  findSymptom (pagination, options) {
    if (!pagination.sort) {
      pagination.sort = 'updateTime'
    }
    if (!pagination.order) {
      pagination.order = 'DESC'
    }
    return Request.post('/ebermain/mainapi/patient/symptom/find', Request.paginationBody(options, pagination))
  },
  saveTag (options) {
    return Request.post('/ebermain/mainapi/patient/symptomTag/save', options)
  },
  deleteTag (options) {
    return Request.post('/ebermain/mainapi/patient/symptomTag/delete', options)
  },
  listTag (options) {
    return Request.post('/ebermain/mainapi/patient/symptomTag/list', options)
  },
  findTag (pagination, options) {
    return Request.post('/ebermain/mainapi/patient/symptomTag/find', Request.paginationBody(options, pagination))
  },
  saveImage (options) {
    return Request.post('/ebermain/mainapi/patient/symptomImage/save', options)
  },
  deleteImage (options) {
    return Request.post('/ebermain/mainapi/patient/symptomImage/delete', options)
  },
  loadImage (options) {
    return Request.post('/ebermain/mainapi/patient/symptomImage/load', options)
  },
  listImage (options) {
    return Request.post('/ebermain/mainapi/patient/symptomImage/list', options)
  }
}
